/**
 * Buy X for Y bundle selector: Afterpay and size guide (scoped to product-bundler-xfy).
 * Loaded with the bundle-selector-xfy block only.
 */
(function () {
  'use strict';

  function bundlerForAfterpayContainer(container) {
    return container && container.closest ? container.closest('product-bundler-xfy') : null;
  }

  /** present-afterpay often injects next to the mount; strip all known fragments inside the bundler before re-init. */
  function removeXfyAfterpayFragments(bundler) {
    if (!bundler || !bundler.querySelectorAll) return;
    bundler.querySelectorAll('.afterpay-paragraph').forEach(function (el) {
      el.remove();
    });
    bundler.querySelectorAll('.afterpay-logo-link').forEach(function (el) {
      el.remove();
    });
  }

  function priceSelectorForContainer(container) {
    if (container && container.id) {
      var id = container.id;
      var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(id) : id;
      return '#' + esc;
    }
    return 'product-bundler-xfy .bundle-selector__afterpay[data-afterpay-amount]';
  }

  function afterpayConfigForContainer(container, amountCents) {
    return {
      priceSelector: priceSelectorForContainer(container),
      amount: amountCents,
      locale: 'en_US',
      currency: 'USD',
      giftCard: false,
      minMaxThreshold: { min: 3500, max: 100000 },
    };
  }

  /**
   * Single mount path: no-op if this amount is already rendered (avoids stacked .afterpay-paragraph).
   * Otherwise clear all Afterpay UI in the bundler and init once.
   */
  function mountXfyAfterpayIfNeeded(bundler, container) {
    if (!container || typeof presentAfterpay === 'undefined') return;

    var intCents = parseInt(container.getAttribute('data-afterpay-amount'), 10) || 0;
    var synced = container.getAttribute('data-xfy-afterpay-synced');
    var hasParagraph = bundler && bundler.querySelector('.afterpay-paragraph');

    if (hasParagraph && synced === String(intCents)) {
      return;
    }

    removeXfyAfterpayFragments(bundler);
    try {
      new presentAfterpay(afterpayConfigForContainer(container, intCents)).init();
      container.setAttribute('data-xfy-afterpay-synced', String(intCents));
    } catch (e) {}
  }

  function initAfterpay() {
    var container = document.querySelector(
      'product-bundler-xfy .bundle-selector__afterpay[data-afterpay-amount]'
    );
    if (!container) return;

    var bundler = bundlerForAfterpayContainer(container);

    function runInit() {
      if (typeof presentAfterpay === 'undefined') {
        setTimeout(runInit, 100);
        return;
      }
      mountXfyAfterpayIfNeeded(bundler, container);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInit);
    } else {
      runInit();
    }
  }

  function initSizeGuide() {
    if (window.__bundleSelectorXfySizeGuideBound) return;
    window.__bundleSelectorXfySizeGuideBound = true;

    document.addEventListener('click', function (e) {
      var sizeGuideButton = e.target.closest('[data-action="size-guide"]');
      if (!sizeGuideButton) return;
      if (!sizeGuideButton.closest('product-bundler-xfy')) return;

      e.preventDefault();
      e.stopPropagation();
      var bundler = sizeGuideButton.closest('product-bundler-xfy');
      var modal = bundler
        ? bundler.querySelector('[id="size-guide-dialog"]')
        : document.getElementById('size-guide-dialog');
      if (!modal) modal = document.getElementById('size-guide-dialog');
      if (modal && typeof modal.showDialog === 'function') {
        modal.showDialog();
      }
    });
  }

  function refreshAfterpayFromEvent(event) {
    var cents = event.detail && event.detail.afterpayAmount;
    if (cents == null) return;
    var bundler =
      event.target && event.target.closest ? event.target.closest('product-bundler-xfy') : null;
    if (!bundler) return;
    var container = bundler.querySelector('.bundle-selector__afterpay[data-afterpay-amount]');
    if (!container) return;

    container.setAttribute('data-afterpay-amount', String(cents));
    mountXfyAfterpayIfNeeded(bundler, container);
  }

  function init() {
    initSizeGuide();
    document.addEventListener('xfy-bundle-pricing-changed', refreshAfterpayFromEvent);
    var afterpayContainer = document.querySelector(
      'product-bundler-xfy .bundle-selector__afterpay[data-afterpay-amount]'
    );
    if (afterpayContainer) {
      var apScript = document.createElement('script');
      apScript.async = true;
      apScript.src = 'https://static-us.afterpay.com/javascript/present-afterpay.js';
      apScript.onload = initAfterpay;
      document.head.appendChild(apScript);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
